export function displayItemName(name, max = 60) {
  const text = typeof name === 'string' ? name.trim() : ''
  if (!text) return ''
  return text.length > max ? `${text.slice(0, max)}...` : text
}

export function displayItemLink(link) {
  if (!link || typeof link !== 'string') return ''
  const raw = link.trim()
  if (!raw) return ''
  try {
    const url = new URL(raw)
    return url.hostname.replace(/^www\./, '')
  } catch {
    const compact = raw.replace(/\s+/g, ' ')
    return compact.length > 40 ? `${compact.slice(0, 40)}…` : compact
  }
}

export function abbreviateAddress(address, max = 42) {
  const text = typeof address === 'string' ? address.trim() : ''
  if (!text) return ''
  const first = (text.split(',')[0] || text).trim()
  return first.length > max ? `${first.slice(0, max - 1)}…` : first
}

export function formatPlaceCardLabel(store) {
  if (!store || typeof store !== 'object') return ''
  const name = typeof store.name === 'string' ? store.name.trim() : ''
  if (name) return name
  return abbreviateAddress(store.address)
}
